// extracted by mini-css-extract-plugin
module.exports = {"AdSlotSticky":"bfy_a bgu_bj bgu_pu","AdSlotSticky__slot":"bfy_b bgu_cx","AdSlotSticky__slot--left":"bfy_c bgu_tw","AdSlotSticky__slot--right":"bfy_e bgu_tx"};